export default __webpack_public_path__ + "static/media/cmb_briefcase.cf3b83e3.svg";